
import { ReactNode } from "react";

interface ReportSectionProps {
  title: string;
  content: string[];
  icon: ReactNode;
  type: 'success' | 'warning' | 'info' | 'overview';
}

export const ReportSection = ({ title, content, icon, type }: ReportSectionProps) => {
  const getBackgroundColor = (type: ReportSectionProps['type']) => {
    switch (type) {
      case 'success':
        return 'bg-green-50 border-green-200';
      case 'warning':
        return 'bg-amber-50 border-amber-200';
      case 'info':
        return 'bg-brand-secondary/10 border-brand-secondary/20';
      case 'overview':
        return 'bg-brand-primary/5 border-brand-primary/10';
      default:
        return 'bg-gray-50 border-gray-100';
    }
  };

  return (
    <div className={`p-6 rounded-lg border shadow-sm ${getBackgroundColor(type)}`}>
      <div className="flex items-center mb-4">
        {icon}
        <h5 className="font-semibold text-brand-dark ml-2">{title}</h5>
      </div>
      {type === 'overview' ? (
        <p 
          className="text-brand-dark leading-relaxed"
          dangerouslySetInnerHTML={{ __html: content[0] }}
        />
      ) : (
        <div className="space-y-4">
          {content.map((point, idx) => (
            <p 
              key={idx}
              className="text-brand-dark leading-relaxed"
              dangerouslySetInnerHTML={{ __html: point }}
            />
          ))}
        </div>
      )}
    </div>
  );
};
